import { EProjectsType } from '../../types/builders';
import { capitalize } from '../string';

const projectsTypesDict = {
  [EProjectsType.Common]: 'типовые',
  [EProjectsType.Individual]: 'индивидуальные',
};

export const formatProjectsTypes = (types: EProjectsType[]): string | null => {
  if (!types.length) {
    return null;
  }

  const projectsTypesString = Object.entries(projectsTypesDict)
    .reduce<string[]>((list, [typeKey, typeValue]) => {
      return types.includes(typeKey as EProjectsType) ? [...list, typeValue] : list;
    }, [])
    .join(' и ');

  return capitalize(projectsTypesString) + ' проекты';
};
